const stripSchemaExamples = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(stripSchemaExamples);
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  return Object.entries(value as Record<string, unknown>).reduce(
    (result, [key, childValue]) => {
      if (key !== "examples") {
        result[key] = stripSchemaExamples(childValue);
      }

      return result;
    },
    {} as Record<string, unknown>
  );
};

export const getSchemaStructureKey = (schema: string | null | undefined) => {
  if (!schema) {
    return "";
  }

  try {
    return JSON.stringify(stripSchemaExamples(JSON.parse(schema)));
  } catch (error) {
    return schema;
  }
};

export const getDynamicFormInstanceKey = (
  schema: string | null | undefined,
  renderKey: number
) => `${getSchemaStructureKey(schema)}-Data-${renderKey}`;
